<template>
	<div class="clue-seas main-content-padding">
		<Panel :contentPaddingTop="12" :contentPaddingBottom="12" class="clue-seas">
			<platform-tab @change="platformClick" :showAll="false" :platformId="platformId" />
			<div class="pos-rela flex-row-align-center mb-24">
				<div
					class="tab-button font-h4-regular"
					:class="[selectFucTab === item.page ? 'active' : '']"
					v-for="item in tabList"
					:key="item.page"
					@click="selectFucTabChange(item.page)"
				>
					<i :class="item.new ? 'i-new' : ''"></i>
					{{ item.name }}
				</div>
			</div>
			<div class="search-form" v-show="showPlatformContent && isTalentTab">
				<filters
					ref="filters"
					:many_partner="many_partner"
					:platformId="platformId"
					:dy-list="dyList"
					:ks-list="ksList"
					:spList="spList"
					@submit="getTalentSeaList"
				/>
			</div>
			<Download-plugin v-if="isAllianceTab" :platformId="platformId" />
		</Panel>
		<Panel v-show="showPlatformContent && isTalentTab">
			<div v-show="list.length" class="fz-14 color-gy-9 flex-row-align-center flex-just-between">
				<div class="flex-row-align-center">
					<span class="font-h4-medium mr-8">海量优质达人，为你拓展新的合作机会</span>
					<div class="fieldDesc-line" />
					<DrawerFieldDesc :descList="descList" title="达人数据指标说明" />
				</div>
				<orderSort :platformId="platformId" @sortChange="sortChange" />
			</div>
			<multi-table
				:key="platformId"
				ref="multiTable"
				:page="pageInfo"
				:list="list"
				:columns="columns"
				@gePartnerList="gePartnerPage"
				layout="sizes, prev, pager, next"
				:total="total"
			>
				<template v-slot:empty>
					<div class="empty-page">
						<div class="i-table-empty"></div>
						<div class="text">未搜索到符合条件的达人</div>
					</div>
				</template>
			</multi-table>
		</Panel>
		<template v-if="isAllianceTab">
			<DyAlliance :platformId="platformId" />
		</template>
		<DetailDrawer ref="detailDrawer" :is-clue-seas="isClueSeas" :activeTab="'1'" />
		<allocation-dialog ref="allocationDialog" :platformId="platformId" @getList="getTalentSeaList" />
		<singleChecksphDialog ref="singleChecksphDialog" @confirm="claimTalent" />
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import throttle from 'lodash/throttle';
import filters from './components/filters';
import DetailDrawer from '../components/detailDrawer';
import TalentInfo from '../components/talentInfo';
import allocationDialog from './components/allocationDialog';
import singleChecksphDialog from './components/singleChecksphDialog';
import { talCategoryList } from '@/api/shopManage';
import { getTalentSeaList, claimTalent, sphCheckAddVideo } from '@/api/talentCRM';
import { PLATFORM_DY, PLATFORM_KS, PLATFORM_SP } from '@/utils/dataMap';
import { platformMixin } from '@rd/rd-ui';
import DyAlliance from './components/dyAlliance.vue';
import DownloadPlugin from './components/downloadPlugin';
import { getColums } from './columns';
import { funcList, TALENT, DYALLIANCE } from './columns';
import { CLUE_SEAS, EMPHASIS_TALENT, MY_TALENT, GROUP_SEAS } from '@/utils/newDataMap/talentCRM';
import talentCRMMixin from '../components/mixins';
import orderSort from './components/orderSort.vue';
import DrawerFieldDesc from '@/components/ui/drawerFieldDesc/index.vue';

export default {
	name: 'clueSeas',
	components: {
		filters,
		DetailDrawer,
		allocationDialog,
		singleChecksphDialog,
		TalentInfo,
		DownloadPlugin,
		DyAlliance,
		orderSort,
		DrawerFieldDesc,
	},
	mixins: [platformMixin, talentCRMMixin],
	created() {
		this.tab = this.$route.query.tab || '';
		this.initTabData();
		this.tab = '';
		// this.platformId = +this.defaultPlatform;
		this.getDyList();
		this.getKsList();
		this.getSpList();
		this.getTalentSeaList();
	},
	mounted() {
		this.$refs.filters.getPartnerAnchor();
	},
	data() {
		return {
			list: [],
			params: {
				cate: '',
				fans_num: '',
				anchor_level: -1,
				anchor_name: '',
				live_count_90: '',
				avg_price: '',
				anchor_account: '',
			},
			platformId: '',
			total: 0,
			pageInfo: {
				page_index: 1,
				page_size: 20,
			},
			dyList: [],
			ksList: [],
			spList: [],
			many_partner: 0,
			tabList: [],
			selectFucTab: '',
			sort: '',
		};
	},
	computed: {
		...mapGetters(['defaultPlatform']),
		isTalentTab({ selectFucTab }) {
			return selectFucTab === TALENT;
		},
		isAllianceTab({ selectFucTab }) {
			return selectFucTab === DYALLIANCE;
		},
		isClueSeas() {
			const asd = this.$route.path === CLUE_SEAS.path;
			return asd;
		},
		columns() {
			const columns = getColums(this).filter(item => {
				return item.isAuth && item.show;
			});
			return columns;
		},
		descList() {
			const arr = [
				{
					title: '30日销售额',
					desc: '近30天达人通过所有来源带货的总销售额',
				},
				{
					title: '带货商品均价',
					desc: '每件出单的商品的平均价格',
				},
				{
					title: '场均销售额',
					desc: '近30天带货直播场次的平均GMV，剔除开播时间小于25分钟的直播',
				},
				{
					title: '单视频销售额',
					desc: '近30天带货视频平均GMV',
				},
			];
			return arr;
		},
	},
	provide() {
		return {
			showDetailDrawer: row => this.showDetailDrawer(row),
		};
	},
	methods: {
		// 切换达人广场 智能推荐达人
		selectFucTabChange(val = '') {
			if (val) this.selectFucTab = val;
			this.mode = 'search';
			if (this.isTalentTab) {
				this.platformClick(this.platformId);
			}
		},

		initTabData() {
			this.tabList = funcList(this).filter(item => {
				return item.isAuth && item.show;
			});
			if (this.tab) {
				this.selectFucTab = this.tabList.find(tab => tab.page === this.tab)?.page;
			} else {
				this.selectFucTab = this.tabList[0]?.page;
			}
		},

		async getDyList() {
			const {
				code,
				data: { list = [] },
			} = await talCategoryList({ platform_id: PLATFORM_DY.value });
			if (code !== 0) return;
			this.dyList = list.map(({ labelId, name }) => ({ label: name, value: labelId + '' }));
		},
		async getKsList() {
			const {
				code,
				data: { list = [] },
			} = await talCategoryList({ platform_id: PLATFORM_KS.value });
			if (code !== 0) return;
			this.ksList = list.map(({ labelId, name }) => ({ label: name, value: labelId }));
		},
		async getSpList() {
			const {
				code,
				data: { list = [] },
			} = await talCategoryList({ platform_id: PLATFORM_SP.value });
			if (code !== 0) return;
			this.spList = list.map(({ labelId, name }) => ({ label: name, value: labelId }));
		},
		async getTalentSeaList(searchForm = {}, isInit) {
			searchForm && Object.keys(searchForm).forEach(key => (this.params[key] = searchForm[key]));
			isInit && this.resetPage();
			const { params, pageInfo, platformId: platform_id } = this;
			const { code, data: { list = [], page = {} } = {} } = await getTalentSeaList({ ...params, ...pageInfo, platform_id, sort: this.sort });
			if (code !== 0) return;
			this.list = list.map(item => {
				return {
					...item,
					operations: this.getButtons(item),
				};
			});
			this.total = page.item_total;
		},
		getButtons(item) {
			const arr = [];
			arr.push(
				{
					label: '认领',
					type: 'text',
					classtype: 2,
					isShow: this.$auth.hasPermi('system:clueSeas:claimant') && !item.is_contact,
					click: async row => {
						if (this.$isSp()) {
							const { need_videono = false } = await sphCheckAddVideo({ anchorId: row.anchor_id });
							if (need_videono) return this.$refs.singleChecksphDialog.show(row, 'claim');
							this.claimTalent(row);
						} else {
							this.claimTalent(row);
						}
					},
				},
				{
					label: '分配',
					type: 'text',
					classtype: 2,
					isShow: this.$auth.hasPermi('system:talent:allocation/re-allocation') && !item.is_contact,
					click: row => this.showAllocationDialog(row),
				},
				{
					label: '详情',
					type: 'text',
					classtype: 2,
					isShow: true,
					click: row => this.showDetailDrawer(row),
				},
			);
			return arr.filter(v => v.isShow);
		},
		showDetailDrawer({ anchor_id, is_contact }) {
			this.$refs.detailDrawer.show(anchor_id, !!is_contact);
		},
		showAllocationDialog(anchor_id) {
			this.$refs.allocationDialog.show(anchor_id);
		},
		claimTalent: throttle(async function ({ anchor_id }, videoNo = '') {
			const { code } = await claimTalent({ anchor_id, videoNo });
			if (code !== 0) return;
			this.$message.success('采集成功');
			this.getTalentSeaList();
		}, 1000),
		gePartnerPage(val) {
			const { page_index, page_size } = val;
			this.pageInfo.page_index = page_index;
			this.pageInfo.page_size = page_size;
			this.getTalentSeaList();
		},
		resetPage() {
			this.pageInfo.page_index = 1;
			this.$refs.multiTable.resetPage();
		},
		platformClick(val) {
			this.platformId = val;
			if (!this.showPlatformContent) return;
			(this.params = {
				cate: '',
				fans_num: '',
				anchor_level: -1,
				anchor_name: '',
				live_count_90: '',
				avg_price: '',
				anchor_account: '',
			}),
				(this.pageInfo = {
					page_index: 1,
					page_size: 20,
				});
			this.initTabData();

			this.$nextTick(() => {
				this.$refs.filters.getPartnerAnchor();
				this.$refs.filters.clueSelectList();
				this.$refs.filters.reset();
			});
		},
		sortChange(sort) {
			this.sort = sort;
			this.getTalentSeaList();
		},
	},
};
</script>

<style lang="less" scoped>
.clue-seas {
	.search-form {
		padding: 0 20px;
		margin-bottom: 12px;
	}

	.is-contact {
		color: #0fb820;
	}

	.empty-page {
		margin-top: 20px;
		display: flex;
		flex-direction: column;
		align-items: center;

		.i-table-empty {
			width: 240px;
			height: 240px;
		}

		.text {
			font-size: 16px;
			color: #999999;
			margin-top: 24px;
		}
	}

	/deep/ .el-pagination {
		.more + .number {
			display: none;
		}
	}
	/deep/ .el-table__fixed {
		box-shadow: 8px 3px 7px rgba(0, 0, 0, 0.08);
	}
	/deep/ .el-table__fixed-right {
		box-shadow: -3px 3px 3px rgba(0, 0, 0, 0.08);
	}
}
.tab-button {
	position: relative;

	i {
		position: absolute;
		right: -28px;
		top: -13px;
	}

	cursor: pointer;
	color: @color-text-regular;

	& + & {
		margin-left: 24px;
	}

	&.active {
		color: @color-primary;
	}
}
</style>
